<template>
  <a-drawer
    placement="right"
    :closable="false"
    :visible="selectedElements.length === 1"
    :mask="false"
    wrapClassName="properties-form-drawer"
    :width="264"
  >
    <template v-if="selectedElements.length === 1">
      <div class="properties-form-container">
        <div class="properties-form-heard">
          <div class="title">组件属性</div>
          <div class="delete-btn" @click="deleteElement">
            <DeleteOutlined />
          </div>
        </div>
        <div class="stencil-icon-and-name">
          <img
            class="icon"
            :src="
              selectedElements[0].model['labelGroupImageAttrs']['xlink:href']
            "
          />
          <div class="name">
            {{ selectedElements[0].model["stencilName"] }}
          </div>
        </div>
        <component
          :is="currentStencil"
          :elementView="selectedElements[0]"
          :elementDataName="elementData.state.elementName"
          :elementDataStateData="elementData.state.data"
          :elementDataMethods="elementData.methods"
        ></component>
      </div>
    </template>
  </a-drawer>
</template>

<script>
import { getPropertiesFormContainers } from "@/stencils";
import { DeleteOutlined } from "@ant-design/icons-vue";

const propertiesFormContainers = getPropertiesFormContainers();

export default {
  components: {
    DeleteOutlined,
    ...propertiesFormContainers,
  },
  data() {
    return {
      selectedElements: [],
    };
  },
  computed: {
    stencilName() {
      let tmp = "";

      if (this.selectedElements.length === 1) {
        tmp = this.selectedElements[0].model.stencilName;
      }

      return tmp;
    },
    elementData() {
      const selectedElements = this.selectedElements;
      if (selectedElements.length === 1) {
        return selectedElements[0].model.elementData;
      } else return null;
    },
    currentStencil() {
      let tmp = "";
      const selectedElements = this.selectedElements;

      if (selectedElements.length === 1) {
        const type = selectedElements[0].model.attributes.type.replace(
          "stencil.",
          ""
        );
        tmp = type;
      }

      return tmp;
    },
  },
  mounted() {
    this.selectedElementChangeHook();
  },
  methods: {
    selectedElementChangeHook() {
      this.$joint.addSelectedElementChangeHook((cellViews) => {
        this.selectedElements = [...cellViews];
      });
    },
    deleteElement() {
      this.$joint.deleteElement(this.selectedElements[0].model.id);
    },
  },
};
</script>

<style lang="less">
@import "@/theme.less";

.properties-form-drawer {
  > .ant-drawer-content-wrapper {
    border-radius: 10px 0 0 10px;
    > .ant-drawer-content {
      border-radius: 10px 0 0 10px;
      > .ant-drawer-wrapper-body {
        border-radius: 10px 0 0 10px;
        > .ant-drawer-body {
          width: 100%;
          border-radius: 10px 0 0 10px;
          padding: 0;
          height: 100%;
          > .properties-form-container {
            width: 100%;
            height: 100%;
            > .properties-form-heard {
              width: 100%;
              border-radius: 10px 0 0 0;
              height: 48px;
              display: flex;
              > .title {
                width: 198px;
                height: 100%;
                display: flex;
                align-items: center;
                padding-left: 16px;
                font-size: 16px;
                color: #ffffff;
                background-color: @container-box-bg;
                border-bottom: 1px solid @container-box-border-color;
              }
              > .delete-btn {
                width: calc(100% - 198px);
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                color: rgba(255, 56, 24, 1);
                background-color: rgba(9, 17, 33, 1);
                cursor: pointer;
              }
            }
            > .stencil-icon-and-name {
              width: 100%;
              display: flex;
              align-items: center;
              padding: 10px;
              > img {
                width: 24px;
                height: 24px;
              }
              > .name {
                margin-left: 20px;
                font-size: 20px;
                font-weight: bold;
                color: @input-color;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
@import "@/theme.less";

.properties-form {
  width: 100%;
  > .properties-form-block {
    width: 100%;
    height: 1px;
    background-color: @container-box-border-color;
  }
  > .properties-form-item {
    display: flex;
    align-items: center;
    padding: 10px;
    width: 100%;
    > .label {
      width: 70px;
      color: @label-color;
      font-weight: @label-font-weight;
    }
    > .form-item {
      width: calc(100% - 70px);
      display: flex;
      align-items: center;
    }
    > .in-port-form-item {
      > .ant-select {
        width: 124px;
      }
      > .anticon {
        margin-left: 10px;
        font-size: 16px;
        cursor: pointer;
      }
      > .anticon-api {
        color: @primary-color;
      }
      > .anticon-minus-circle {
        color: rgba(255, 56, 24, 1);
      }
    }
    > .out-port-form-item {
      > .ant-select {
        width: 150px;
      }
      > .anticon-minus-circle {
        cursor: pointer;
        margin-left: 10px;
        font-size: 16px;
        color: rgba(255, 56, 24, 1);
      }
    }
    > .full-select {
      > .ant-select {
        width: 100%;
      }
    }
  }
  > .in-port-form-btn-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px;
  }
  > .out-port-form-btn-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 10px;
  }
}
</style>
